export default function isAnnouncementsDisabled (entryDate: string): boolean {

  if (entryDate === '') return true
  const now = new Date(Date.now()).toISOString()
  return now < entryDate

}
